/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
// @ts-ignore
import type { StoreSku } from './StoreSku';
// @ts-ignore
import {
// @ts-ignore
    StoreSkuFromJSON,
// @ts-ignore
    StoreSkuFromJSONTyped,
// @ts-ignore
    StoreSkuToJSON,
} from './StoreSku';

/**
 * 
 * @export
 * @interface StoreInventoryListResponse
 */
export interface StoreInventoryListResponse {
    /**
     * 
     * @type {number}
     * @memberof StoreInventoryListResponse
     */
    totalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof StoreInventoryListResponse
     */
    estimatedTotalCount: number;
    /**
     * 
     * @type {Array<StoreSku>}
     * @memberof StoreInventoryListResponse
     */
    items: Array<StoreSku>;
}

/**
 * Check if a given object implements the StoreInventoryListResponse interface.
 */
// @ts-ignore
export function instanceOfStoreInventoryListResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "estimatedTotalCount" in value;
    isInstance = isInstance && "items" in value;

    return isInstance;
}

// @ts-ignore
export function StoreInventoryListResponseFromJSON(json: any): StoreInventoryListResponse {
    return StoreInventoryListResponseFromJSONTyped(json, false);
}

// @ts-ignore
export function StoreInventoryListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): StoreInventoryListResponse {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'total_count') ? undefined : json['total_count'],
        'estimatedTotalCount': json['estimated_total_count'],
        'items': ((json['items'] as Array<any>).map(StoreSkuFromJSON)),
    };
}

// @ts-ignore
export function StoreInventoryListResponseToJSON(value?: StoreInventoryListResponse | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total_count': value.totalCount,
        'estimated_total_count': value.estimatedTotalCount,
        'items': ((value.items as Array<any>).map(StoreSkuToJSON)),
    };
}

